import { IconButton, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { PiChatsCircle } from "../Icons";

const SupportBubble = () => {
  const theme = useTheme();

  const ZOOM_SUPPORT_LINK =
    "https://us06web.zoom.us/j/83125127335?pwd=5pbyePhQ7p028w6qWhwUPDaoW0MyVe.1";

  return (
    <Tooltip title="Contact Support" placement="left">
      <IconButton
        sx={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          backgroundColor: theme.palette.primary.main,
          color: "white",
          zIndex: 1300,
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.25)",
          width: "60px",
          height: "60px",
          transition: "transform 0.2s ease-in-out",
          "&:hover": {
            backgroundColor: theme.palette.primary.dark,
            transform: "scale(1.1)",
          },
        }}
        size="large"
        aria-label="support chat"
        href={ZOOM_SUPPORT_LINK}
        target="_blank"
        rel="noopener noreferrer"
      >
        <PiChatsCircle sx={{ fontSize: "30px" }} />
      </IconButton>
    </Tooltip>
  );
};

export default SupportBubble;
